import {ACTION_TYPES} from 'constants/ActionTypes';

export default (state = {}, action) => {
  switch (action.type) {
    case ACTION_TYPES.OPEN_POPUP_PRODUCT_DETAIL:
      return {
        ...state,
        isOpen: action.isOpen,
        scrollY: action.scrollY,
        data: action.data
      };
    case ACTION_TYPES.CLOSE_POPUP_PRODUCT_DETAIL:
      return {
        ...state,
        isOpen: action.isOpen,
        data: null
      };
    case ACTION_TYPES.DISPLAY_LOADING_POPUP:
      return {
        ...state,
        isLoading: action.isLoading
      };
    case ACTION_TYPES.OPEN_REQUEST_FORM_PRODUCT:
      return {
        ...state,
        isOpenForm: action.isOpenForm,
        productId: action.productId
      };
    case ACTION_TYPES.CLOSE_REQUEST_FORM_PRODUCT:
      return {
        ...state,
        isOpenForm: action.isOpenForm
      };
    default:
      return state;
  }
};



// WEBPACK FOOTER //
// ./reducers/product.js